import DestacatDirecte from './DestacatDirecte';
import DestacatDirecteSkeleton from './DestacatDirecteSkeleton';

export default function Component(props) {
    const { isLoading } = props;
    return isLoading ? <DestacatDirecteSkeleton /> : <DestacatDirecte {...props} />;
}
